import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const companyOutgoingRequestsSlice = createSlice({
    name: 'ui/company-outgoing-requests',
    initialState: { ...initialState, populates: ['location', 'hostId', 'contactIds'] },
    reducers: listReducers
})

export const companyOutgoingRequestsActions = companyOutgoingRequestsSlice.actions
export default companyOutgoingRequestsSlice.reducer
